function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#222",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.984 0c4.114 0 7.734 2.512 9.901 5.637.153.221.153.506 0 .728C17.722 9.525 14.13 12 9.985 12c-4.19 0-7.712-2.467-9.87-5.62-.157-.227-.153-.52.011-.741C2.936 1.879 6.506 0 9.984 0zm.002 1C6.855 1 3.642 2.566 1.114 5.699c-.148.185-.152.428-.011.617C3.046 8.944 6.215 11 9.986 11c3.73 0 6.964-2.062 8.91-4.696.138-.185.138-.422 0-.607C16.947 3.093 13.689 1 9.987 1z",
  transform: "translate(2 6)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 2c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4zm0 1C8.343 3 7 4.343 7 6s1.343 3 3 3 3-1.343 3-3-1.343-3-3-3z",
  transform: "translate(2 6)"
}));

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.ef94a457.svg";
export { ForwardRef as ReactComponent };